import { Alert, Form, Input, Modal, Select } from 'antd'

import { TRANSPORT_REQUEST_TEXTS as T } from './TransportRequest.types'

export interface LossReasonOption {
    value: string
    label: string
}

export interface LossReasonModalProps {
    open: boolean
    /** Варіанти довідника причин програшу (запиту, тендера чи заявки) */
    options: LossReasonOption[]
    loading?: boolean
    value: string | undefined
    onChange: (value: string | undefined) => void
    /** Поле «Коментар» (заявка, Р21.4); у запиту й тендера його немає */
    withComment?: boolean
    comment?: string
    onCommentChange?: (value: string) => void
    commentMaxLength?: number
    /** 422 причини — під полем */
    fieldError?: string | null
    /** Інша помилка, яку ще можна виправити повторною відправкою */
    error?: string | null
    pending?: boolean
    onSubmit: () => void
    onCancel: () => void
}

/**
 * «Вкажіть причину програшу» (`SPEC-022` §8.4; легасі
 * `useDrawerLossButton.jsx:87-102`): одне поле-select без підпису,
 * обов'язкове — перевіряє бек, 422 лягає під поле. Легасі ховав «Закрити»;
 * тут хрестик і «Закрити» лишаються, як в інших модалках.
 *
 * Компонент лише малює: стан і запит — у сторі власника
 * (`TransportRequestActionsStore`), тож та сама модалка служить запиту,
 * тендеру й заявці (`withComment`, Р21.4).
 */
export const LossReasonModal = ({
    open,
    options,
    loading = false,
    value,
    onChange,
    withComment = false,
    comment = '',
    onCommentChange,
    commentMaxLength,
    fieldError,
    error,
    pending = false,
    onSubmit,
    onCancel,
}: LossReasonModalProps) => (
    <Modal
        title={T.loseModalTitle}
        open={open}
        okText={T.save}
        cancelText={T.close}
        okButtonProps={{ loading: pending }}
        onOk={onSubmit}
        onCancel={onCancel}
        destroyOnHidden
        maskClosable={false}
    >
        {error ? <Alert type="error" showIcon title={error} style={{ marginBottom: 16 }} /> : null}
        <Form layout="vertical" component="div">
            <Form.Item
                required
                validateStatus={fieldError ? 'error' : ''}
                help={fieldError ?? undefined}
                style={{ marginBottom: withComment ? 16 : 0 }}
            >
                <Select
                    value={value}
                    options={options}
                    loading={loading}
                    showSearch
                    optionFilterProp="label"
                    allowClear
                    onChange={(next: string | undefined) => onChange(next)}
                    style={{ width: '100%' }}
                    aria-label={T.loseModalTitle}
                />
            </Form.Item>
            {withComment ? (
                <Form.Item label={T.comment} style={{ marginBottom: 0 }}>
                    <Input.TextArea
                        rows={4}
                        value={comment}
                        {...(commentMaxLength ? { maxLength: commentMaxLength } : {})}
                        onChange={(event) => onCommentChange?.(event.target.value)}
                    />
                </Form.Item>
            ) : null}
        </Form>
    </Modal>
)
